module.exports = __webpack_public_path__ + "img/HeaderExample.4c9b0275.png";